import { ApiAppsSource, type AppsSource, GnbShell } from "@workith/gnb";
import "@workith/gnb/style.css";
import { type ReactNode, useState } from "react";
import { getGatewayApiUrl } from "../../lib/backendUrl";
import type { User } from "../../types/user";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";

interface LayoutProps {
  user: User;
  children: ReactNode;
}

function createGnbAppsSource(setUnavailable: (unavailable: boolean) => void): AppsSource {
  const source = new ApiAppsSource(getGatewayApiUrl("/api/gnb/apps"), {
    credentials: "include",
  });
  return {
    async getApps() {
      try {
        const apps = await source.getApps();
        setUnavailable(false);
        return apps;
      } catch {
        setUnavailable(true);
        return [];
      }
    },
  };
}

export function Layout({ user, children }: LayoutProps) {
  const [gnbUnavailable, setGnbUnavailable] = useState(false);
  const [gnbAppsSource, setGnbAppsSource] = useState<AppsSource>(() =>
    createGnbAppsSource(setGnbUnavailable)
  );

  const retryGnb = () => {
    setGnbUnavailable(false);
    setGnbAppsSource(createGnbAppsSource(setGnbUnavailable));
  };

  return (
    <GnbShell currentAppId="editor" appsSource={gnbAppsSource}>
      <div className="flex h-full min-h-0 overflow-hidden">
        <Sidebar />
        <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          <Header user={user} />
          {gnbUnavailable && (
            <div
              role="alert"
              className="flex items-center justify-between bg-amber-50 px-4 py-2 text-sm"
            >
              <span>앱 목록을 불러오지 못했습니다.</span>
              <button type="button" className="underline" onClick={retryGnb}>
                다시 시도
              </button>
            </div>
          )}
          <div className="min-h-0 flex-1 overflow-y-auto scroll-pt-32 bg-muted/40">{children}</div>
        </main>
      </div>
    </GnbShell>
  );
}
